import _ from 'lodash'
import moment from 'moment'
import async from 'async'
const { setFormButtons } = require('../../../apps/KpModule/actions')
import { decrypt } from '../../utils/crypto'
import { sendMail } from './ticketsSendMail'
import { basicContext } from "../../utils/contextUtils"
import { getTicketNotificationData } from "./utils/notifications"
import { setFieldVisibility } from "../../../apps/KpModule/actions"

const sendButton = {
    type: 'save',
    tKey: 'send',
    bsStyle: 'success'
}

const closeButton = {
    type: 'action',
    action: 'close',
    tKey: 'close',
    bsStyle: 'primary'
}

const returnButton = {
    type: 'return',
    tKey: 'return',
    bsStyle: 'default'
}

const decryptUser = o => ({...o, mail: decrypt(o.mail)})

export async function generateAndSendMails(object, oldObject, context) {
    try {
        console.log('--> Sending ticket emails')

        const action  = context.restAction && context.restAction.crudType
        const groupModelName = (context.groupModel && context.groupModel.name) || 'Keenpoint'
        const userContext = _.get(context, 'user')
        const noReply = (context.group && context.group.noReply) || 'no-reply@keenpoint.com'
        const link = global.isProd
            ? `https://${context.host}/business/${context.groupModel.id}/communication/m-${context.model.id}-tickets`
            : `http://localhost:3000/business/${context.groupModel.id}/communication/m-${context.model.id}-tickets`

        const ticketSubject = await global.app[context.model.id].TicketSubject.find({
            ...basicContext(context),
            fieldPath: ['id', 'users.id', 'users.mail', 'users.name'],
            query: {
                _id: new global.ObjectID(_.get(object, 'ticketSubject.id'))
            }
        })

        const modelAdmins = ticketSubject.flatMap(o => o.users)

        const mailOptions = {
            groupModelName,
            numTicket: object.formattedNumTicket,
            theme: object.ticketSubjectName,
            sender: _.get(context, 'user'),
            link,
            noReply
        }
        if(action === 'C') {
            sendMail({...mailOptions, recipient: userContext, type: 'creation'}, (error, msg) => {console.log(`${msg} - to user`)})
            modelAdmins.forEach(modelAdmin => {
                sendMail({...mailOptions, recipient: decryptUser(modelAdmin), type: 'adminNotification'}, (error, msg) => {console.log(`${msg} - to admin`)})
            })
        } else {
            if(object.user.id === _.get(context, "user.id")) {
                sendMail({...mailOptions, recipient: userContext, type: 'update'}, (error, msg) => {console.log(`${msg} - to user`)})
                modelAdmins.forEach(modelAdmin => {
                    sendMail({...mailOptions, recipient: decryptUser(modelAdmin), type: 'adminNotification'}, (error, msg) => {console.log(`${msg} - to admin`)})
                })
            } else {
                sendMail({...mailOptions, recipient: decryptUser(object.user), type: 'response'}, (error, msg) => {console.log(`${msg} - to user`)})
            }
        }
        return 'OK'
    } catch (e) {
        throw(e)
    }
}

export const entities = () => [
    {
        name: 'TicketSubject',
        facets: [{name: 'translatedField', referenceField: 'wording'}],
        fields: [
            {path:'wording', notEmpty: true},
            {path: 'active', type: 'boolean', default: true},
            {path: 'profiles', type: 'Profile', link: 'MTM'},
            {path: 'users', type: 'User', link: 'MTM'}
        ],
        filters: [
            {
                name: 'active',
                isDefault: false,
                query: function(context) {
                    return {active: true}
                }
            },
            {
                name: 'profileMatchUserContext',
                isDefault: false,
                async: true,
                query: function(context, callback) {
                    const profiles = global.User.getUserProfilesFromGroupModel(context.user, context.groupModel)
                    if(profiles.length) {
                        callback(null, {
                            profiles: {$in: profiles.map(o => new global.ObjectID(o.id))}
                        })
                    } else {
                        callback(null, {id: null})
                    }
                }
            }
        ]
    },
    {
        name: 'TicketStatus',
        type: 'static',
        facets: ['translatedField'],
        fields: [
            {path: 'id', type: 'string'},
            {path: 'name', type: 'string'},
        ],
        objects: [
            {id: 'inProgress', name: 'inProgress'},
            {id: 'closed', name: 'closed'},
            {id: 'autoClosed', name: 'autoClosed'}
        ]
    },
    {
        name: 'Ticket',
        facets: ['conversations'],
        fields: [
            {
                path: "numTicket", unique: true, ps: {
                    object: [{
                        type: "nextSequence",
                        sequenceId: "kp.tickets",
                        formatResult: result => `${result}`
                    }]
                }
            },
            'TicketSubject',
            {type:'User', nullable: true},
            {type:'TicketStatus', nullable: true},
            { path: 'creationDate', type: 'date', dateFormat: 'YYYY-MM-DD HH:mm', nullable: true},
            {
                path: 'formattedNumTicket',
                fieldPath: ['creationDate', 'numTicket'],
                f: function () {
                    return `${moment(this.creationDate).format('YYMMDD')}_${this.numTicket}`
                }
            },
            {
                path: 'ticketSubjectName',
                fieldPath: ['ticketSubject.tWording'],
                f: function () {
                    return _.get(this, 'ticketSubject.tWording')
                }
            },
            {
                path: 'lastContributor',
                f: function() {
                    if(this.conversations?.length) {
                        const comment = _.last(_.orderBy(this.conversations, 'timestamp'))
                        return _.get(comment, 'sender.name')
                    }
                    return ''
                }
            },
            {
                path: 'lastUpdate',
                f: function() {
                    if(this.conversations?.length) {
                        const update = _.last(_.orderBy(this.conversations, 'timestamp')).timestamp
                        return moment(update).format('YYYY-MM-DD HH:mm')
                    }
                    return ''
                }
            },
            {
                path: 'greenStyledRow',
                nullable: true,
                fieldPath: ['id', 'ticketStatus.id', 'conversations.sender.id', 'user.id'],
                $f: function (ticket, context, callback) {
                    const lastComment = _.last(_.orderBy(ticket.conversations, 'timestamp'))
                    const isOwner = _.get(ticket, 'user.id') === _.get(context, 'user.id')
                    callback(
                        null,
                        ticket.id && lastComment &&
                        ticket.ticketStatus && ticket.ticketStatus.id === 'inProgress' &&
                        (
                            isOwner && _.get(lastComment, 'sender.id') !== _.get(context, 'user.id') ||
                            !isOwner && _.get(lastComment, 'sender.id') === _.get(ticket, 'user.id')
                        )

                    )
                }
            },
            {
                path: 'buttons',
                fieldPath: ['id', 'ticketStatus.id', 'user.id'],
                $f: function (ticket, context, callback) {
                    const buttons = []
                    if(ticket.id) {
                        if(ticket.ticketStatus.id !== 'closed') {
                            const aditionalButtons = context.user.id === ticket.user.id
                                ? [sendButton, closeButton]
                                : [sendButton]
                            buttons.push(...aditionalButtons)
                        }
                    } else {
                        buttons.push(sendButton)
                    }
                    buttons.push(returnButton)
                    callback(null, buttons)
                }
            }
        ],
        beforeSave: function(object, oldObject, context, callback) {
            const action  = context.restAction && context.restAction.crudType
            // initialize status, user and creation date
            if(action === 'C') {
                object.ticketStatus =  {id: 'inProgress'}
                object.creationDate = new Date()
                object.user = context.user
            }

            if(context.action === 'close') {
                object.ticketStatus = {id: 'closed'}
            }

            callback(null, object, oldObject)
        },
        afterSave: function(object, oldObject, context, callback) {
            if(object.ticketStatus.id !== 'closed') {
                generateAndSendMails(object, oldObject, context)
                    .then(result => {
                        console.log(`Mails sent ${result}`)
                    })
                    .catch(err => {
                        console.error(err.message)
                    })
            }

            getTicketNotificationData({
                userId: _.get(context, 'user.id'),
                groupId: _.get(context, 'group.id'),
                modelId: _.get(context, 'model.id')
            }
            ).then( data => global.ioSocket.emit('afterSave', data) )

            callback(null, object)
        },
        filters: [
            {
                name: 'ownMessageOrGroupModelAdmin',
                isDefault: false,
                async: true,
                query: function(context, callback) {
                    global.app[context.model.id].TicketSubject.find({
                        ...basicContext(context),
                        fieldPath: ['id'],
                        query: {
                            users: new global.ObjectID(_.get(context, 'user.id'))
                        }
                    }, (e, ticketSubjects) => {
                        if(e) return callback(e)
                        const query = {
                            $or: [
                                { user: new global.ObjectID(context.user.id) },
                                { ticketSubject: {$in: ticketSubjects.map(o => new global.ObjectID(o.id))} },
                            ]
                        }
                        callback(e, query)
                    })

                }
            },
            {
                name: 'byStatusTicket',
                title: 'ticketStatus',
                path: 'ticketStatus',
                object: 'TicketStatus',
                display: 'name',
                client: true,
                translate: true,
                default: {id: 'inProgress'},
                query: function(context) {
                    const ticketStatusId = _.get(context.data, 'ticketStatus.id')
                    return ticketStatusId
                        ? {ticketStatus: ticketStatusId}
                        : {}
                }
            }
        ],
        ps: {
            context: [{
                $$u: function (context, callback) {
                    if (this.options.accessType === "S" && context.restAction && context.restAction.crudType === "C") {
                        context.internalFieldPath = [
                            ...new Set([
                                ...context.internalFieldPath,
                                "numTicket"
                            ])
                        ]
                    }
                    callback(null, context)
                }
            }]
        },
    }
]

export const modules = () => [
    {
        tKey: "m-T-TicketSubject",
        object: "TicketSubject",
        category: {
            path: 'menuTitle_communication',
            icon: 'speech'
        },
        objectIdentifier: 'wording',
        defaultSortBy: 'wording',
        defaultSortDirection: 'ASC',
        viewMap: {
            dt: [
                {
                    path: 'wording',
                    translateName: true,
                    tKey: 'subject'
                },
                {path: 'profiles', tKey: 'profile(s)', translateName: true},
                {path: 'users', tKey: 'contact(s)'},
                'active'
            ],
            form: [
                {
                path: 'wording',
                type: 'textarea',
                tKey: 'subject',
                placeholder: 'fr:: Sujet du message en français\nen:: Sujet du message en Anglais'
                },
                {
                    path: 'profiles',
                    tKey: 'profile(s)',
                    filters: ['thisModel'],
                    translateName: true
                },
                {
                    path: 'users',
                    tKey: 'contact(s)',
                    filters: ['isComAdmin']
                },
                'active'
            ]
        }
    },
    {
        tKey: "m-T-Ticket",
        name: "tickets",
        category: {
            path: 'menuTitle_communication',
            icon: 'speech'
        },
        object: "Ticket",
        objectIdentifier: 'formattedNumTicket',
        removable: false,
        defaultSortBy: 'lastUpdate',
        defaultSortDirection: 'DESC',
        viewMap: {
            dt: [
                {path: 'formattedNumTicket', tKey: 'requestNumber', width: 100},
                {path: 'ticketSubject', tKey: 'subject', display: 'tWording', width: 400},
                {path: 'user', tKey: 'applicant', width: 100},
                {path: 'creationDate', tKey: 'requestDate', width: 100},
                {path: 'lastUpdate', tKey: 'updatedOn', width: 100},
                {path: 'lastContributor', tKey: 'updatedBy', width: 100},
                {path: 'ticketStatus', width: 50},
                {path: 'greenStyledRow', hidden: true}
            ],
            form: {
                fields: [
                    {path: 'formattedNumTicket', tKey: 'requestNumber', type: 'readOnly'},
                    {path: 'ticketSubject', tKey: 'subject', display: 'tWording', editable: false, filters: ['profileMatchUserContext', 'active']},
                    {path: 'conversations'},
                    // Hidden fields
                    {path: 'ticketStatus', hidden: true},
                    {path: 'creationDate', hidden: true},
                    {path: 'user', display: 'fullName', hidden: true},
                    {path: 'buttons', hidden: true}
                ],
                onOpen: ({ store }) => {
                    const state = store.getState()
                    const objectMode = state.ui.objectMode
                    store.dispatch(setFieldVisibility(`e_formattedNumTicket`, objectMode !== 'newObject'))
                    if(objectMode === 'newObject') {

                        store.dispatch(
                            setFormButtons(
                                [sendButton, returnButton]
                            )
                        )
                    }
                }
            }
        },
        filters: [
            'ownMessageOrGroupModelAdmin',
            'byStatusTicket'
        ]
    }
]

export const jobs = () => [{
    name: 'closeOldTickets',
    title: 'Close tickets older than 30 days',
    cron: '5 1 * * *',
    single: true,
    execute: function(context, callback) {
        const modelId = _.get(context, 'model.id')
        console.log(`Model ${modelId}: Closing tickets older than 30 days`)

        global.GroupModel.find({
            fieldPath: ["id", "group.id"],
            query: {model: modelId}
        }, (e, groupModels) => {
            async.each(
                groupModels,
                (groupModel, callback) => {
                    const groupId = _.get(groupModel, 'group.id')
                    const groupModelName = _.get(groupModel, 'name')
                    global.app[modelId].Ticket.find({
                        query: {ticketStatus: 'inProgress'},
                        fieldPath: ['id', 'name', 'user.id', 'conversations.sender.id', 'conversations.timestamp'],
                        group: new global.ObjectID(groupId)
                    }, (e, tickets) => {
                        if(e) return callback(e)

                        const thirtyDaysAgo = moment().subtract(30, 'days')
                        const oldTickets = tickets.filter(ticket => {
                            const lastComment = _.last(_.orderBy(ticket.conversations, 'timestamp'))

                            return lastComment && moment(lastComment.timestamp).isBefore(thirtyDaysAgo)
                        })

                        if(oldTickets.length) {
                            global.app[modelId].Ticket.collection.updateMany(
                                {_id: {$in: oldTickets.map(o => new global.ObjectID(o.id))}},
                                { $set: {'ticketStatus': 'autoClosed'} }
                            ).then(() => {
                                console.log(`Group Model ${groupModelName}: ${oldTickets.length} tickets closed`)
                                callback(null, `Group Model ${groupModelName}: ${oldTickets.length} tickets closed`)
                            }).catch(callback)
                        } else {
                            console.log(`Group Model ${groupModelName}: No tickets closed`)
                            callback()
                        }
                    })
                },
                e => {
                    if(e) return callback(e)
                    callback(null, {message: `Model ${modelId}: Closing tickets DONE`})
                }
            )
        })
    }
}]

